import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AudienceSection } from './components/AudienceSection';
import { ProcessSection } from './components/ProcessSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-gray-300 font-sans selection:bg-brand-orange/30 selection:text-white overflow-x-hidden" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <AudienceSection data-id="element-5" />
        <ProcessSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <OfferSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}